<template>
  <div class="min-h-screen bg-slate-50">
    <!-- Navigation Header -->
    <NavBar />

    <!-- Hero Section -->
    <HeroSection />

    <!-- About Section -->
    <AboutSection />

    <!-- Skills Section -->
    <SkillsSection />

    <!-- Projects Section -->
    <ProjectsSection @open-modal="openProjectModal" @open-all-projects="showAllProjects = true" @view-image="openImageModal" />

    <!-- Contact Section -->
    <ContactSection />

    <!-- Footer -->
    <AppFooter />

    <!-- All Projects Modal -->
    <AllProjectsModal v-if="showAllProjects" @close="showAllProjects = false" @open-details="openProjectModal" @view-image="openImageModal" />

    <!-- Project Detail Modal -->
    <ProjectModal :project="selectedProject" @close="closeProjectModal" @view-image="openImageModal" />

    <!-- Image Lightbox Modal -->
    <ImageModal v-if="selectedImage" :image-url="selectedImage" @close="selectedImage = null" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import NavBar from './NavBar.vue'
import HeroSection from './HeroSection.vue'
import AboutSection from './AboutSection.vue'
import SkillsSection from './SkillsSection.vue'
import ProjectsSection from './ProjectsSection.vue'
import AppFooter from './AppFooter.vue'
import ProjectModal from './ProjectModal.vue'
import AllProjectsModal from './AllProjectsModal.vue'
import ImageModal from './ImageModal.vue'
import ContactSection from './ContactSection.vue'

const selectedProject = ref(null)
const showAllProjects = ref(false)
const selectedImage = ref(null)

const openProjectModal = (project) => {
  selectedProject.value = project
}

const closeProjectModal = () => {
  selectedProject.value = null
}

const openImageModal = (imageUrl) => {
  selectedImage.value = imageUrl
}

onMounted(() => {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault()
      const target = document.querySelector(this.getAttribute('href'))
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  })
})
</script>
